import Permission from '@/users/entities/permission'

export default class PermissionAssignment {

  public permissions: Permission[] = []
  public assignments: {[role: string]: string[]} = {}
}
